const FBCLID_STORAGE_KEY = 'fbclid';

const getFbclidFromUrl = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('fbclid') || '';
};

const getCookie = (name) => {
  try {
    const prefix = `${name}=`;
    const cookies = document.cookie ? document.cookie.split(';') : [];
    for (const cookie of cookies) {
      const trimmed = cookie.trim();
      if (trimmed.startsWith(prefix)) {
        return decodeURIComponent(trimmed.slice(prefix.length));
      }
    }
  } catch (error) {
    return '';
  }
  return '';
};

/**
 * Persist fbclid from the URL so it survives browsing before checkout.
 * A new fbclid in the URL overwrites the stored value.
 */
export const captureFbclid = () => {
  try {
    const urlFbclid = getFbclidFromUrl();
    if (!urlFbclid) {
      return;
    }

    localStorage.setItem(FBCLID_STORAGE_KEY, urlFbclid);
  } catch (error) {
    // localStorage may be unavailable (private mode / restricted browsers)
  }
};

/**
 * Prefer fbclid from the current URL, then fall back to localStorage.
 */
export const getFbclid = () => {
  try {
    return getFbclidFromUrl() || localStorage.getItem(FBCLID_STORAGE_KEY) || '';
  } catch (error) {
    return getFbclidFromUrl() || '';
  }
};

export const getFbp = () => getCookie('_fbp');

export const getFbc = () => getCookie('_fbc');

/**
 * Optional Meta Ads identifiers for checkout POST bodies.
 * Omits missing keys. Does not invent values or hash them.
 */
export const getMetaAdsParams = () => {
  captureFbclid();

  const fbclid = getFbclid();
  const fbp = getFbp();
  const fbc = getFbc();

  return {
    ...(fbclid ? { fbclid } : {}),
    ...(fbp ? { fbp } : {}),
    ...(fbc ? { fbc } : {}),
  };
};

const trackedPurchaseIds = new Set();

/**
 * Browser Pixel Purchase, using the same eventID the backend sends to CAPI
 * (subscription / order id) so Meta can deduplicate.
 */
export const trackMetaPurchase = (eventId, value) => {
  const id = eventId == null || eventId === '' ? '' : String(eventId);
  if (!id || trackedPurchaseIds.has(id)) {
    return;
  }
  if (typeof window.fbq !== 'function') {
    return;
  }

  trackedPurchaseIds.add(id);

  try {
    window.fbq(
      'track',
      'Purchase',
      {
        value: Number(value) || 0,
        currency: 'BRL',
      },
      { eventID: id }
    );
  } catch (error) {
    trackedPurchaseIds.delete(id);
  }
};
